<template>
  <div class="flight-reviewed-value-control">
    <app-date-picker
      v-if="fieldKey === 'date'"
      design="new"
      :value="value"
      :clearable="false"
      :editable="false"
      format="DD MMM YYYY"
      value-type="YYYY-MM-DD"
      placeholder="Select date"
      @input="$emit('input', $event)"
    />
    <app-date-picker
      v-else-if="fieldKey === 'time'"
      design="new"
      :value="value"
      type="time"
      :clearable="false"
      :editable="false"
      :show-second="false"
      format="HH:mm"
      value-type="HH:mm"
      placeholder="Select time"
      @input="$emit('input', $event)"
    />
    <app-select
      v-else-if="fieldKey === 'airport_iata'"
      design="new"
      :value="value"
      :options="airportOptions"
      :reduce="airport => airport.short_name"
      :display-field="airportLabel"
      :clearable="false"
      placeholder="Select an airport"
      @input="$emit('input', $event)"
    />
    <app-checkbox
      v-else-if="fieldKey === 'flight_domestic'"
      design="new"
      :value="Boolean(value)"
      label="This is a domestic flight"
      @input="$emit('input', $event)"
    />
    <app-input
      v-else
      design="new"
      :value="value"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import AppDatePicker from '@/components/AppDatePicker'

export default {
  name: 'FlightTicketReviewedValueControl',
  components: { AppDatePicker },
  props: {
    fieldKey: { type: String, required: true },
    value: { default: null },
    airports: { type: Array, default: () => [] },
  },
  computed: {
    airportOptions() {
      const result = [...this.airports]
      const code = this.normalizeAirport(this.value)
      if (code && !result.some(airport => this.normalizeAirport(airport.short_name) === code)) {
        result.unshift({ id: null, name: 'Unmapped airport', short_name: code })
      }
      return result
    },
  },
  methods: {
    airportLabel(airport) {
      return [airport?.short_name, airport?.name].filter(Boolean).join(' · ')
    },
    normalizeAirport(value) {
      return value ? String(value).trim().toUpperCase() : ''
    },
  },
}
</script>

<style lang="sass" scoped>
.flight-reviewed-value-control
  width: 100%
  min-width: 0

  \:deep(.datepicker)
    width: 100%
</style>
